import React from 'react'
import Slider from 'react-slick'
import our_partners_1 from './static/img/our_partners_1.png'
import our_partners_2 from './static/img/our_partners_2.png'
import our_partners_3 from './static/img/our_partners_3.png'
import our_partners_4 from './static/img/our_partners_4.png'
import our_partners_5 from './static/img/our_partners_5.png'
import our_partners_6 from './static/img/our_partners_6.png'
import $ from 'jquery'

function OurPartnersSection() {
  let slider_settings = { 
    autoplay: true,
    infinite: true,
    autoplaySpeed: 1000,
    speed: 950,
    slidesToShow: $(window).width() > 900 ? 5 : ($(window).width() > 500 ? 3 : 1),
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    draggable: true
  }

  return (
            <div className="our_partners_section" style={{overflow:"hidden"}}>
                <h2 className="our_partners_title">Our partners</h2>
                <Slider {...slider_settings} className="our_partners_slider slick-partners-slider">
                    <div className="our_partners_slider_item"><img src={our_partners_1} alt="" /></div>
                    <div className="our_partners_slider_item"><img src={our_partners_2} alt="" /></div>
                    <div className="our_partners_slider_item"><img src={our_partners_3} alt="" /></div>
                    <div className="our_partners_slider_item"><img src={our_partners_4} alt="" /></div>
                    <div className="our_partners_slider_item"><img src={our_partners_5} alt="" /></div>
                    <div className="our_partners_slider_item"><img src={our_partners_6} alt="" /></div>
                </Slider>
            </div>
  )
}

export default OurPartnersSection